import React from "react";
import classNames from "classnames";

export default function ProgressItem(props) {
  const { name, val, label, diff, animateDiff } = props;

  return (
    <div
      className={classNames("progress__item", {
        "is-positive": val > 0,
        "is-negative": val < 0
      })}
    >
      <div className="progress__item-top">
        <div className="progress__val">{val}</div>
        <div className="progress__icon">
          <i className={`own-it-icon icon-${name}`}>
            {diff !== 0 && (
              <span
                className={classNames("progress__diff", {
                  "is-positive": diff > 0,
                  "is-negative": diff < 0,
                  "is-animated": animateDiff
                })}
              >
                {diff > 0 && "+"}
                {diff}
              </span>
            )}
          </i>
        </div>
      </div>
      <div className="progress__text">{label}</div>
    </div>
  );
}
